import NumberInput from "./numberInput.element";
import {CSSProperties} from "react";
import {Tooltip} from "@mui/material";

interface NumberInputLabelProps {
    title: string;
    value: number;
    step?: string;
    tooltip?: string;
    style?: CSSProperties;
    inputStyle?: CSSProperties;
    onChange(value: number): void;
}

function NumberInputLabel(props: NumberInputLabelProps) {
    return (
        <div className={'layout horizontal stretch gap flex-grow'}
             style={{...{alignItems: 'center', gap: 10}, ...props.style}}>
            <div className={'layout horizontal center gap'}>
                <p className={'flex-grow'}>{props.title}</p>
                {props.tooltip && <Tooltip title={props.tooltip} arrow disableInteractive>
                    <span className={'fa-light fa-info-circle'} style={{color: 'white'}}/>
                </Tooltip>}
            </div>
            <NumberInput value={props.value} step={props.step} style={props.inputStyle} onChange={props.onChange}/>
        </div>
    )
}

export default NumberInputLabel;
